<div class="min-w300 car-box-pop-details" [ngStyle]="{'border': '1px solid' + appointmentSlotDetails.workOrderColor, 'border-top': '5px solid' + appointmentSlotDetails.workOrderColor}" id="pop-box_day_mechId" style="display: block;"
    #slotPosition>
    <div class="card-header border-bottom p-2">
        <div class="d-flex align-items-center">
            <div class="tooltipSubheader mr-2">
                #{{appointmentSlotDetails.workOrderNo}}
            </div>
            <div class="licplate LPNo tooltipheader">
                {{appointmentSlotDetails.licensePlate}}
            </div>
            <img af-brand-logo data-type="BRAND" [data-code]="appointmentSlotDetails.brandCode" [ngbTooltip]="appointmentSlotDetails.brandCode"  tooltipClass="my-tooltip"
            class="{{appointmentSlotDetails.brandCode}}-icon common" class="brandicon mr-2" alt="" />
            <div *ngIf="isAnyWarrantyDemand" class="ml-auto mr-2" style="font-size: 16px;">
                <em class="fas fa-award font20" style="color: gray;"></em>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <ul class="list-group list-group-flush text-dark">
            <li class="list-group-item p-2 d-flex align-items-center" *ngIf="!showTotalHours">
                <em class="fas icon-clockic mr-2 font20"></em>
                {{appointmentStartDate}} - {{appointmentEndDate}}
            </li>
            <li class="list-group-item p-2 d-flex align-items-center" *ngIf="showTotalHours">
                <em class="fas icon-clockic mr-2 font20"></em>
                <span translate> lblPlannedTime  </span>  : {{ appointmentSlotDetails.totalHours }} 
            </li>
            <li class="list-group-item p-2 d-flex align-items-center" *ngIf="isView">
                <em class="fas icon-business-m mr-2 font20"></em>
                {{dealerName}} -
                {{appointmentSlotDetails.customerName}}
            </li>
            <li class="list-group-item p-2 d-flex align-items-center" *ngIf="!isView">
                <em class="fas icon-business-m mr-2 font20"></em>
                {{appointmentDetails.dealerName}} -
                {{appointmentSlotDetails.customerName}}
            </li>
            <li class="list-group-item p-2 d-flex align-items-center">
                <em class="fas icon-mechanic mr-2 font20"></em>
                {{appointmentSlotDetails.mechanicName}}
            </li>
            <li class="list-group-item p-2" style="text-align: left;" *ngIf="appointmentSlotDetails.appointmentDemands.length > 0">
                <div *ngFor="let demand of appointmentSlotDetails.appointmentDemands; let i = index;">
                    <div *ngIf="demand.number" class="d-flex align-items-center">
                        <em class="fas fa-award mr-2 font20 under-warranty-text" *ngIf="demand.isUnderWarranty"></em>
                        <em class="fas fa-award mr-2 font20" *ngIf="!demand.isUnderWarranty && isAnyWarrantyDemand" style="visibility: hidden;"></em>
                        <span [ngClass]="{ 'under-warranty-text': demand.isUnderWarranty }">{{demand.number}} - {{demand.shortDescription}}</span>
                    </div>
                    <div *ngIf="!demand.number" class="d-flex align-items-center">
                        <ng-container *ngFor="let description of FormatDemandDescription(demand.shortDescription)">
                          <div>{{description}}</div>
                        </ng-container>
                      </div>
                </div>
            </li>
        </ul>
    </div>
</div>
